import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Barline/editor/barlineeditor.tsx",
    () => import("./barlineeditor"),
);
